import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5m0ewx9kld: FaireBrandEntity = {
  token: "b_5m0ewx9kld",
  type: "brand",
  name: "Elemental Wellness | Soap & Toxin-Free Living",
  avatarUrl:
    "https://cdn.faire.com/fastly/088d32137b34d1e7d5952105bd8c5ca90dd8658e7765b28b677ef58413e315ab.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9cc84bfb3b754c0619a7d20702b25c1da4f7ea4816022cd502b3d1d06dfaf49b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/088d32137b34d1e7d5952105bd8c5ca90dd8658e7765b28b677ef58413e315ab.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9cc84bfb3b754c0619a7d20702b25c1da4f7ea4816022cd502b3d1d06dfaf49b.png",
  location: "Delta, CO, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "It all started with a bar of soap. \n\nAfter years of unknowingly using toxic products, I had an aha moment that changed everything—I realized just how disconnected I was from nature and how much harm those ingredients were causing. I wanted to live cleaner, more intentionally, and in alignment with the Earth.\n\nWith a BS in Alternative Medicine and an MS in Ayurveda & Integrative Medicine, I returned to what I always knew deep down: Mother Earth provides everything we need to heal. So I began handcrafting my own products—starting with herbs, roots, and oils from the Earth, and blending them with intention, love, and purpose.\n\nElemental Wellness Shop was born from this mission: to help others return to nature, simplify their routines, and feel safe in what they use on their bodies and in their homes. Every product is small batch, made with sustainably sourced herbs, and rooted in our values of honesty, sustainability, and love.\n\nWe believe wellness shouldn’t be complicated. Nature has already provided the answers. We’re just here to remind you.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:32.586Z",
    importedBy: "entity-db-cli",
  },
};
